<template>
  <div class="text-header">
    <h2>{{ header }}</h2>
  </div>
</template>

<script>
export default  {
  props: {
    header: String,
  }
}
</script>

<style scoped lang="scss">
  .text-header h2 {
    font-size: 20px;
    font-weight: 600;
    line-height: 120%;
    margin-bottom: 0;
    min-width: max-content;
  }

  @media (max-width: $mobile-breakpoint) {
    .text-header {
      display: none;
    }
  }
</style>